export enum Platfrom {
  ANDROID = 'android',
  IOS = 'ios',
  HARMONYOS = 'harmonyos',
  PC = 'pc',
}
